import { getQueryWithoutSourceMentions } from '#pplx/frontend/apps/ask/ask-input/query-serialization/lexicalNodeToQuery.js';
import { resolveAutosuggestQuery } from '#pplx/frontend/apps/ask/suggest-dropdown/hooks/resolveAutosuggestQuery.js';
import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import { useCallback } from 'react';
/** Shares the input's edit, blank-state click, and submission-reset behavior. */
export function useAskInputAutosuggestActions({ blankStateSuggestions, handleUpdateAutosuggestions, selectedSearchMode, setSuggestions, suggestionsDisabled = false, }) {
    const updateSuggestions = useCallback((inputQuery, inputJson) => {
        if (suggestionsDisabled) {
            setSuggestions([]);
            return;
        }
        const request = resolveAutosuggestQuery({
            inputQuery,
            queryWithoutSourceMentions: getQueryWithoutSourceMentions(inputJson?.root, inputQuery),
        });
        switch (request.kind) {
            case 'source-only':
                setSuggestions([]);
                handleUpdateAutosuggestions('');
                return;
            case 'blank': {
                const blankSuggestions = blankStateSuggestions[selectedSearchMode];
                setSuggestions(blankSuggestions?.length ? blankSuggestions : []);
                handleUpdateAutosuggestions(request.query);
                return;
            }
            case 'query':
                handleUpdateAutosuggestions(request.query);
                return;
            case 'ignored':
                return;
            default:
                assertUnreachableValue(request);
        }
    }, [
        blankStateSuggestions,
        handleUpdateAutosuggestions,
        selectedSearchMode,
        setSuggestions,
        suggestionsDisabled,
    ]);
    const showBlankSuggestions = useCallback((inputQuery) => {
        if (inputQuery.length === 0 && blankStateSuggestions[selectedSearchMode]?.length) {
            setSuggestions(blankStateSuggestions[selectedSearchMode]);
        }
    }, [blankStateSuggestions, selectedSearchMode, setSuggestions]);
    const resetSuggestions = useCallback(() => {
        setSuggestions([]);
        handleUpdateAutosuggestions('');
    }, [handleUpdateAutosuggestions, setSuggestions]);
    return { updateSuggestions, showBlankSuggestions, resetSuggestions };
}
//# sourceMappingURL=useAskInputAutosuggestActions.js.map